// extracted by mini-css-extract-plugin
module.exports = {"container":"InsuranceContractTypesTab_container__3pYHs"};